import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownLong, faUpload } from '@fortawesome/free-solid-svg-icons';
import { withAppHOC } from '../../hoc';
import PageHeading from '../../components/PageHeader/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import NoData from '../../components/NoData/NoData';
import {
  MessageBox,
  Form,
  Fieldset,
  Button,
  ResetButton,
  Label,
  Dropdown,
  TextInput,
  FormContainer,
} from '../../components/FormElements';
import {
  StyledLink,
  StyledFiltersContainer,
  StyledSpan,
  StyledModalContainer,
  StyledButtonAsLink,
} from '../../components/Styled';
import { TableBuilder } from '../../components/TableElements';
import Pagination from '../../components/Pagination/Pagination';
import API from '../../api';
import { API_RESPONSE_TYPES } from '../../constants';
import {
  getSearchParams,
  shouldRedirect,
  redirectToPageOne,
  formatCurrency,
  getBase64,
} from '../../utils';
import FiltersButton from '../../components/FiltersButton/FiltersButton';
import { isEmpty } from 'lodash';
import Modal from '../../components/Modal';
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader';

const BuyerInvoices = (props) => {
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams('pageNumber') || 1,
    recordsPerPage: getSearchParams('recordsPerPage') || 10,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersId, setUsersId] = useState('');
  const [date, setDate] = useState('');
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');

  const [modalState, setModalState] = useState({
    showModal: false,
    id: '',
    isLoading: false,
    status: '',
    message: '',
    file: '',
  });

  const uploadInvoice = async (e) => {
    e.preventDefault();
    setModalState((prevState) => ({
      ...prevState,
      isLoading: true,
      state: '',
      message: '',
    }));
    try {
      console.log(modalState);
      const response = await API.put(
        `/invoicing/upload-buyer-invoices/${modalState?.id}`,
        {
          file: modalState.file,
        }
      );
      const { status, message } = response.data;
      setModalState((prevState) => ({
        ...prevState,
        status: status,
        message: message,
      }));
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        reloadData();
        setTimeout(() => {
          setModalState((prevState) => ({
            ...prevState,
            showModal: false,
            id: '',
            isLoading: false,
            status: '',
            message: '',
            file: '',
          }));
        }, 3000);
      }
    } catch (error) {
      setModalState((prevState) => ({
        ...prevState,
        status: API_RESPONSE_TYPES.FAILED,
        message: error.message,
      }));
    } finally {
      setModalState((prevState) => ({
        ...prevState,
        isLoading: true,
      }));
    }
  };

  const resetForm = () => {
    setUsersId('');
    setYear('');
    setMonth('');
    setDate('');
    readData();
  };

  const readUsers = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get('/accounts-management/users?pageNumber=1&recordsPerPage=100000')
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setUsers(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readData = useCallback(
    (usersId = '', year = '', month = '') => {
      setIsLoading(true);
      setResponseStatus('');
      setResponseMessage('');
      API.get(
        `/invoicing/buyers/?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&usersId=${usersId}&year=${year}&month=${month}`
      )
        .then((response) => {
          const { status, message, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            if (status === API_RESPONSE_TYPES.FAILED) {
              setResponseStatus(status);
              setResponseMessage(message);
            } else {
              setTotalRecords(pageInfo.totalRecords);
            }
            setData(data);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILED);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  const reloadData = () => {
    readData(usersId, year, month);
  };

  //   const updateData = (value, data, key) => {
  //     const newData = { ...data };
  //     newData[key] = value === true ? `Active` : `Inactive`;
  //     setIsLoading(true);
  //     setResponseStatus("");
  //     setResponseMessage("");
  //     API.put(
  //       `/recharge-configurations/seller-apis/${newData.id}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&usersId=${usersId}`,
  //       newData
  //     )
  //       .then((response) => {
  //         const { status, message, data } = response.data;
  //         if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
  //           redirectToPageOne();
  //         } else {
  //           if (status === API_RESPONSE_TYPES.FAILED) {
  //             setResponseStatus(status);
  //             setResponseMessage(message);
  //           } else {
  //             setSellerApis(data);
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         setResponseStatus(API_RESPONSE_TYPES.FAILED);
  //         setResponseMessage(error.message);
  //       })
  //       .finally(() => {
  //         setIsLoading(false);
  //       });
  //   };

  const filterData = (e) => {
    e.preventDefault();
    setIsFiltering(true);
  };

  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    if (!isFiltering) {
      readData(usersId, year, month);
    }
  }, [paginationData, readData]);

  const [showFilters, setShowFilters] = useState(false);
  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  useEffect(() => {
    readUsers();
  }, [readUsers]);

  useEffect(() => {
    if (!isEmpty(date)) {
      const splitedDate = date.split('-');
      setYear(splitedDate[0]);
      setMonth(splitedDate[1]);
    } else {
      setYear('');
      setMonth('');
    }
  }, [date]);

  const usersOptions = [{ title: '-- SELECT USER --', value: '' }];
  users.forEach(({ id, fullName }) =>
    usersOptions.push({
      title: fullName,
      value: id,
    })
  );

  return (
    <>
      <PageHeading {...props} reloadData={reloadData} />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? 'show' : ''}>
        <Form method="POST" action="#" onSubmit={filterData}>
          <Fieldset>
            <Label>User</Label>
            <Dropdown
              value={usersId}
              onChange={setUsersId}
              placeholder="User"
              disabled={isLoading}
              options={usersOptions}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>Year & Month</Label>
            <TextInput
              type="month"
              value={date}
              onChange={setDate}
              placeholder="Month"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Button disabled={isLoading} type="submit">
              Filter
            </Button>
            <ResetButton disabled={isLoading} type="button" onClick={resetForm}>
              Clear
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <LoadingSpinner
        isLoading={responseStatus === '' && data?.length === 0 && isLoading}
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILED &&
          !isLoading &&
          data?.length === 0
        }
        message={`No invoices found`}
      />
      {responseStatus === API_RESPONSE_TYPES.FAILED && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      {data?.length > 0 && (
        <>
          <TableBuilder
            isLoading={data?.length !== 0 && isLoading}
            tableHeadings={[
              {
                title: '',
                dataSelector: 'id',
                sticky: true,
                canSort: false,
                width: '100px',
                CellRenderer: (_, item) => {
                  return (
                    <>
                      {item.invoiceFile && (
                        <StyledLink
                          to={item.invoiceFile}
                          title="Download"
                          target="_blank"
                        >
                          <FontAwesomeIcon icon={faDownLong} /> Download
                        </StyledLink>
                      )}
                      {!item.invoiceFile && (
                        <StyledButtonAsLink
                          onClick={() => {
                            setModalState((prevState) => ({
                              ...prevState,
                              showModal: true,
                              id: item.id,
                              isLoading: false,
                              status: '',
                              message: '',
                              file: '',
                            }));
                          }}
                        >
                          <FontAwesomeIcon icon={faUpload} /> Upload
                        </StyledButtonAsLink>
                      )}
                    </>
                  );
                },
              },
              {
                title: 'User',
                dataSelector: 'fullName',
                dataType: 'string',
                CellRenderer: (value, item) => (
                  <>
                    {value}
                    <StyledSpan>{item?.mobileNumber}</StyledSpan>
                  </>
                ),
              },
              {
                title: 'Year',
                dataSelector: 'year',
                dataType: 'string',
              },
              {
                title: 'Month',
                dataSelector: 'month',
                dataType: 'string',
              },
              {
                title: 'Amount',
                dataSelector: 'amount',
                dataType: 'string',
                CellRenderer: (value) => formatCurrency(value) || 'N/A',
              },
            ]}
            tableData={data}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={modalState.showModal}
            setModalStatus={() => {
              setModalState((prevState) => ({
                ...prevState,
                showModal: false,
                id: '',
                isLoading: false,
                status: '',
                message: '',
                file: '',
              }));
            }}
            hideCloseButton
          >
            <StyledModalContainer width={`500px`}>
              <h3>Upload Invoice PDF</h3>
              <FormContainer>
                <Form method="POST" action="#" onSubmit={uploadInvoice}>
                  <Fieldset>
                    <Label required>Please select invoice file</Label>
                    <br></br>
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          getBase64(file, (base64) => {
                            setModalState((prevState) => ({
                              ...prevState,
                              file: base64,
                            }));
                          });
                        }
                      }}
                      placeholder="Please select invoice pdf"
                      disabled={modalState.isLoading}
                    />
                  </Fieldset>
                  {modalState.showModal && modalState.status !== '' && (
                    <Fieldset>
                      <MessageBox
                        status={modalState.status}
                        message={modalState.message}
                      />
                    </Fieldset>
                  )}
                  <Fieldset>
                    <Button
                      disabled={modalState.isLoading || modalState.file === ''}
                      type="submit"
                      style={{ width: 'auto' }}
                    >
                      Upload
                    </Button>
                  </Fieldset>
                  <OverlayLoader
                    showLoader={modalState.showModal && modalState.isLoading}
                  />
                </Form>
              </FormContainer>
            </StyledModalContainer>
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(BuyerInvoices);
